<app-spinner [size]="50" [isOpen]="!loading" [hasTrappedFocus]="true" (close)="loading = false"></app-spinner>